import { PortalUser } from 'bones/utils/portal/usePortalUser';

const LETTER_REGEXP = /[A-Z]/i;

export const getPortalUserInitials = (
  user: PortalUser
): [string, string] | null => {
  const firstInitial = user.first_name?.[0]?.toUpperCase() || null;
  const lastInitial = user.last_name?.[0]?.toUpperCase() || null;

  if (
    !firstInitial ||
    !lastInitial ||
    !firstInitial.match(LETTER_REGEXP) ||
    !lastInitial.match(LETTER_REGEXP)
  ) {
    return null;
  }

  return [firstInitial, lastInitial];
};
